<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                <div class="body-2 mb-2">
                  Range Tanggal
                </div>

                <v-menu
                  ref="range"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.range">
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      single-line
                      :color="set_color"
                      placeholder="Contoh. 2023-01-01 s/d 2023-12-01"

                      hide-details

                      v-on="on"
                      v-bind="attrs"

                      v-model="date_range"
                      class="mb-2"
                      style="border-radius: 10px !important;">
                    </v-text-field> -->

                    <v-card
                      v-on="on"
                      v-bind="attrs"

                      flat
                      color="#f2f2f2"
                      class="mb-2"
                      style="border-radius: 10px;">
                      <div
                        class="d-flex align-center pa-3">
                        <v-icon>mdi-calendar-multiselect-outline</v-icon>

                        <div
                          class="body-1 ml-1">
                          {{ filter.dates[0] | date_month }} - {{ filter.dates[1] | fulldate }}
                        </div>
                      </div>
                    </v-card>
                  </template>
                  
                  <v-date-picker 
                    range
                    :color="set_color"
                    v-model="filter.dates"
                    @input="picker.range = filter.dates.length > 1 ? false : true">
                  </v-date-picker>
                </v-menu>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="650"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mt-2 mb-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div v-if="form.sallary_json_array.length > 0">
                    <v-row
                      class="mb-3">
                      <v-col
                        cols="12"
                        md="6">
                        <ValidationProvider 
                          name="Nomor Rekening" 
                          rules="required"
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>

                            Nomor Rekening
                          </div>

                          <v-text-field
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense

                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            type="number"
                            min="0"

                            :color="set_color"
                            placeholder="Contoh. 03910XXXX"

                            hide-details

                            v-model="form.account_number"
                            :success="valid"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
                              
                              <div v-if="form.account_number !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>

                    <ValidationProvider 
                      name="Atas Nama Rekening" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>

                        Atas Nama Rekening
                      </div>

                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        filled
                        rounded
                        dense
                        
                        :color="set_color"
                        placeholder="Contoh. John Doe"
                        
                        hide-details

                        v-model="form.account_name"
                        :success="valid"
                        :error-messages="errors"
                        required
                        class="mb-3"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
                          
                          <div v-if="form.account_name !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>

                    <v-row
                      class="mb-3">
                      <v-col
                        cols="12"
                        md="6">
                        <div>
                          <div 
                            class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Mulai
                          </div>

                          <v-menu
                            ref="start"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.start_date">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Mulai" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  readonly
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-01"

                                  hide-details

                                  clearable
                                  @click:clear="form.start_date = ''; form.end_date = '';"

                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.start_date"
                                  :success="form.start_date !== '' && valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.start_date !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              v-model="form.start_date"
                              @input="picker.start_date = false; form.end_date = '';">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6">
                        <div>
                          <div 
                            class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Selesai
                          </div>

                          <v-menu
                            ref="end"
                            min-width="290px"
                            max-width="290px"
                            transition="scale-transition"
                            offset-y
                            :nudge-right="40"
                            :close-on-content-click="false"
                            v-model="picker.end_date">
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Selesai" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  readonly
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Contoh. 2023-12-31"

                                  hide-details

                                  clearable
                                  @click:clear="form.end_date = ''"

                                  v-on="on"
                                  v-bind="attrs"

                                  v-model="form.end_date"
                                  :success="form.end_date !== '' && valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.end_date !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>

                            <v-date-picker 
                              :color="set_color"
                              :min="form.start_date"
                              v-model="form.end_date"
                              @input="picker.end_date = false">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                    
                    <div
                      v-for="(item, index) in form.sallary_json_array"
                      :key="index"
                      :class="index > 0 ? 'mt-6' : ''">
                      <div
                        class="body-1 black--text text-capitalize d-flex align-center mb-2"
                        style="font-weight: 500;">
                        <v-icon small color="black">mdi-transfer-right</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ item.type }}
                        </span>
                      </div>

                      <div
                        v-for="(item_sub, index_sub) in item.child"
                        :key="index_sub">
                        <v-row
                          align="center">
                          <v-col
                            cols="12"
                            md="5">
                            <div
                              class="d-flex align-center">
                              <v-icon>mdi-circle-small</v-icon>

                              <span
                                class="body-2">
                                {{ item_sub.label }}
                              </span>
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="7">
                            <ValidationProvider
                              :name="item_sub.label" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-currency-field
                                filled
                                rounded
                                dense

                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"

                                @focus="$event.target.select()"
                                v-on:keydown.tab="formula().values(index)"
                                @keyup="formula().values(index)"
                                @blur="formula().values(index)"
                                @change="formula().values(index)"

                                :color="set_color"
                                placeholder="Rp 0"

                                hide-details

                                v-model="item_sub.nominal"
                                :success="item_sub.nominal !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>

                                  <div v-if="item_sub.nominal !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </div>

                      <v-card
                        flat
                        color="#f0f0f0"
                        class="mt-2"
                        style="border-radius: 10px;">
                        <v-card-text
                          class="py-0">
                          <v-row
                            align="center">
                            <v-col
                              cols="12"
                              md="5">
                              <div
                                class="body-1 black--text text-capitalize"
                                style="font-weight: 500;">
                                Total {{ item.type }}
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="7">
                              <div
                                class="title black--text font-weight-bold ml-5">
                                {{ item.child.reduce((a, item) => a + Number(item.nominal), 0) | price }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>

                    <v-card
                      flat
                      color="#f0f0f0"
                      class="mt-6 mb-2"
                      style="border-radius: 10px;">
                      <v-card-text
                        class="py-0">
                        <v-row
                          align="center">
                          <v-col
                            cols="12"
                            md="5">
                            <div
                              class="body-1 black--text text-capitalize"
                              style="font-weight: 500;">
                              Total Take Home Pay
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="7">
                            <div
                              class="title black--text font-weight-bold ml-5">
                              {{ Number(form.thp) | price }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div v-else>
                    <div
                      class="mb-1">
                      Konfigurasi gaji belum di set !!!
                    </div>

                    <div
                      class="d-flex align-center">
                      Silahkan set konfigurasi gaji di menu <strong class="ml-1">Informasi Gaji</strong> <v-icon small class="mx-1">mdi-arrow-right</v-icon> <router-link to="/salary/now"><strong>Konfigurasi Gaji</strong></router-link>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.upload"
          @keydown.esc="dialog.upload = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Upload Slip Gaji

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.upload = false; dialog.fullscreen = false; selected.upload = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              <div
                class="mb-2">
                Silahkan upload slip gaji dibawah ini:
              </div>

              <uploaddocument 
                v-model="upload.doc">
                <div 
                  slot="activator">
                  <v-btn
                    :disabled="process.doc"
                    :loading="process.doc"
                    block
                    :color="`${set_color_rgb_down}`"
                    elevation="0"
                    class="body-2 font-weight-bold text-capitalize d-flex align-center"
                    style="border-radius: 8px;"
                    :style="`color: ${set_color};`">
                    <div>
                      <v-img
                        contain
                        width="20"
                        height="20"
                        alt="amanata"
                        :src="require('@/assets/icon/upload_folder.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              size="20"
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <span
                      class="ml-2">
                      Upload Slip Gaji (PDF)
                    </span>
                  </v-btn>
                </div>
              </uploaddocument>

              <div v-if="form.slip_url !== ''"
                class="mt-4">
                <iframe 
                  :src="`${form.slip_url}#toolbar=0`" 
                  allowfullscreen
                  frameborder="0" 
                  width="100%"
                  height="500"
                  style="border-radius: 15px; border: 2px solid #323639;">
                </iframe>
              </div>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="uploads()"
                :loading="process.upload"
                :disabled="process.upload"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.upload = false; dialog.fullscreen = false; selected.upload = [];"
                :disabled="process.upload"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="amanata"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Gaji Bulanan
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <!-- <v-btn
                      @click="dialog.form = true; reset();"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn> -->
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="8">
              <div
                class="body-2">
                Periode gaji

                <span v-if="filter.dates.length > 0">
                  dari <strong class="black--text">{{ filter.dates[0] | date_month }}</strong>
                </span>

                <span v-if="filter.dates.length > 0">
                  - <strong class="black--text">{{ filter.dates[1] | fulldate }}</strong>
                </span>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="4"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>

              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dialog.filter = true;"
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-filter-multiple-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div>

              <!-- FREEZE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div>

              <!-- HIDE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="user_id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="amanata" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="dialog.form = true; reset(index);"

                              v-bind="attrs"
                              v-on="on"

                              :disabled="!list[index].status < 1"
                              min-width="28"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-plus-circle-multiple</v-icon>
                            </v-btn>
                          </template>

                          <span>Tambah</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(value)"

                              v-bind="attrs"
                              v-on="on"

                              :disabled="!list[index].status > 0"
                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Hapus</span>
                        </v-tooltip>

                        <v-menu
                          right
                          offset-y
                          style="box-shadow: none !important;">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="#37474F"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list
                            dense
                            color="#808080"
                            class="py-1 my-2"
                            style="border-radius: 10px !important;">
                            <v-list-item
                              class="px-2">
                              <v-tooltip 
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :to="`/salary/month/detail/${value}`"

                                    v-bind="attrs"
                                    v-on="on"

                                    :disabled="!list[index].status > 0"
                                    min-width="28"
                                    small
                                    rounded
                                    color="#78909C"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-information-slab-circle-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Detail</span>
                              </v-tooltip>
                            </v-list-item>

                            <v-list-item
                              class="px-2">
                              <v-tooltip 
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="toUpload(value)"

                                    v-bind="attrs"
                                    v-on="on"

                                    :disabled="!list[index].status > 0"
                                    min-width="28"
                                    small
                                    rounded
                                    color="orange"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-cloud-upload-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Upload Slip Gaji</span>
                              </v-tooltip>
                            </v-list-item>

                            <v-list-item
                              class="px-2">
                              <v-tooltip
                                right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :href="list[index].slip_url"
                                    target="_blank"

                                    v-bind="attrs"
                                    v-on="on"

                                    :disabled="list[index].slip_url === ''"

                                    min-width="28"
                                    small
                                    rounded
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-link</v-icon>
                                  </v-btn>
                                </template>

                                <span>Lihat Slip Gaji</span>
                              </v-tooltip>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        <v-chip
                          small
                          rounded
                          :color="value > 0 ? 'green' : 'red'"
                          elevation="0"
                          class="text-capitalize white--text mx-1 d-flex justify-center"
                          style="font-weight: 600; width: 130px;">
                          {{ value > 0 ? 'Sudah Ditransfer' : 'Belum Ditransfer' }}
                        </v-chip>
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,

          upload: false
        },
        
        search: '',

        filter: {
          dates: [
            moment().startOf('month').format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ]
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],

          upload: []
        },

        bank: [
          {
            text: 'BRI',
            value: 'BRI',
            icon: require('@/assets/bank/bri.png')
          },
          {
            text: 'BNI',
            value: 'BNI',
            icon: require('@/assets/bank/bni.png')
          },
          {
            text: 'Mandiri',
            value: 'Mandiri',
            icon: require('@/assets/bank/mandiri.png')
          },
          {
            text: 'BCA',
            value: 'BCA',
            icon: require('@/assets/bank/bca.png')
          },
          {
            text: 'BSI',
            value: 'BSI',
            icon: require('@/assets/bank/bsi.png')
          },
          {
            text: 'CIMB',
            value: 'CIMB',
            icon: require('@/assets/bank/cimb.png')
          },
          {
            text: 'BTN',
            value: 'BTN',
            icon: require('@/assets/bank/btn.png')
          },
          {
            text: 'Genius',
            value: 'Genius',
            icon: require('@/assets/bank/genius.png')
          },
          {
            text: 'Danamon',
            value: 'Danamon',
            icon: require('@/assets/bank/danamon.png')
          },
          {
            text: 'Bukopin',
            value: 'Bukopin',
            icon: require('@/assets/bank/bukopin.png')
          },
          {
            text: 'Permata',
            value: 'Permata',
            icon: require('@/assets/bank/permata.png')
          }
        ],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        picker: {
          range: false,

          start_date: false,
          end_date: false
        },

        upload: {
          doc: null
        },

        form: {
          id: '',
          user_id: '',
          account_number: '',
          account_name: '',
          start_date: moment().startOf('month').format('YYYY-MM-DD'),
          end_date: moment().endOf('month').format('YYYY-MM-DD'),
          sallary_json_array: [],
          thp: 0,

          slip_url: ''
        },

        process: {
          load: false,

          form: false,

          delete: false,

          doc: false,
          upload: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_pdf.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },

      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC

              this.form.slip_url = this.upload.doc.fileuri
            }
          }
        },
        deep: true
      },
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb < 10 ? `0${numb}`.toString() : numb.toString()

        return [
          {
            text: 'Januari',
            value: '01'
          },
          {
            text: 'Februari',
            value: '02'
          },
          {
            text: 'Maret',
            value: '03'
          },
          {
            text: 'April',
            value: '04'
          },
          {
            text: 'Mei',
            value: '05'
          },
          {
            text: 'Juni',
            value: '06'
          },
          {
            text: 'Juli',
            value: '07'
          },
          {
            text: 'Agustus',
            value: '08'
          },
          {
            text: 'September',
            value: '09'
          },
          {
            text: 'Oktober',
            value: '10'
          },
          {
            text: 'November',
            value: '11'
          },
          {
            text: 'Desember',
            value: '12'
          }
        ]
      },
      years () {
        let max = new Date().getFullYear(), min = max - 10, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(Number(value))) return 'Not a Number'
          let price = ''

          const reverseNumber = Number(value)
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = parseInt(value) + '%'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,

          start_date: this.filter.dates.length > 0 ? this.filter.dates[0] : '',
          end_date: this.filter.dates.length > 0 ? this.filter.dates[1] : ''
        }

        this.selected.row = []

        await get(`admin/user_sallary/data_user`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '140px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Status',
                width: '150px',
                value: 'status',
                freeze: false,
                hide: false,
                align: 'center',
                format: 'status'
              },
              {
                text: 'Nomor Induk Pegawai',
                width: '200px',
                value: 'user_code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'user_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Unit / Divisi',
                width: '300px',
                value: 'unit_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal Mulai',
                width: '200px',
                value: 'start_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Tanggal Selesai',
                width: '200px',
                value: 'end_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              // {
              //   text: 'Nama Bank',
              //   width: '200px',
              //   value: 'account_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nomor Rekening',
                width: '200px',
                value: 'account_number',
                freeze: false,
                hide: false
              },
              {
                text: 'Atas Nama Rekening',
                width: '300px',
                value: 'account_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Take Home Pay',
                width: '200px',
                value: 'thp',
                freeze: false,
                hide: false,
                align: 'end',
                format: 'number'
              }
            ]

            // this.list = res.results.data
            let data = res.results.data

            data.forEach(obj => {
              this.list.push({
                id: obj.id,
                user_id: obj.user_id,
                user_name: obj.user_name,
                user_code: obj.user_code,
                unit_name: obj.unit_name,
                account_number: obj.account_number,
                account_name: obj.account_name,
                thp: obj.thp,
                start_date: obj.start_date,
                end_date: obj.end_date,
                slip_url: obj.slip_url,
                sallary_json_array: obj.sallary_json_array,

                status: Number(obj.thp)
              })
            })

            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async fetchMaster () {
        let params = {
          limit: 100000,

          is_active_bool: true,

          user_id: this.form.user_id
        }

        await get(`admin/user_config_sallary/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = res.results.data

            let arrs = []
            
            data.forEach(obj => {
              if (!arrs.find(item => item.type === obj.type)) {
                arrs.push({
                  id: obj.id,
                  company_id: obj.company_id,
                  label: obj.label,
                  is_active_bool: obj.is_active_bool,
                  category: obj.category,
                  type: obj.type,
                  order_by: obj.order_by,
                  nominal: obj.nominal,
                  child: []
                })
              }

              arrs.forEach(obj_sub => {
                if (obj_sub.type === obj.type) {
                  obj_sub.child.push({
                    id: obj.id,
                    company_id: obj.company_id,
                    label: obj.label,
                    is_active_bool: obj.is_active_bool,
                    category: obj.category,
                    type: obj.type,
                    order_by: obj.order_by,
                    nominal: obj.nominal
                  })
                } 
              })
            })

            this.form.sallary_json_array = arrs

            this.form.thp = 0

            let total_income = 0, total_deduction = 0

            arrs.forEach(obj => {
              if (obj.type === 'income') {
                total_income += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
              } 
              
              if (obj.type === 'deduction') {
                total_deduction += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
              }
            })

            this.form.thp = total_income - total_deduction
          }
        })
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          user_id: index !== undefined ? this.list[index].user_id : '',

          account_number: index !== undefined ? this.list[index].account_number : '',
          account_name: index !== undefined ? this.list[index].account_name : '',

          start_date: index !== undefined && this.list[index].start_date !== '' ? this.list[index].start_date : moment().startOf('month').format('YYYY-MM-DD'),
          end_date: index !== undefined && this.list[index].end_date !== '' ? this.list[index].end_date : moment().endOf('month').format('YYYY-MM-DD'),
          sallary_json_array: index !== undefined ? this.list[index].sallary_json_array : [],
          thp: index !== undefined ? this.list[index].thp : 0,

          slip_url: ''
        }

        if (index !== undefined && (this.list[index].account_number === '' || this.list[index].account_name === '')) {
          this.fetchDetailUser(this.list[index].user_id)
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form && this.form.sallary_json_array.length < 1) this.fetchMaster()
      },

      async fetchDetailUser (id) {
        let params = {
          id: id
        }

        await get(`admin/user/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            let data = res.results.data
            
            this.form.account_number = data.account_number
            this.form.account_name = data.account_name
          }
        })
      },

      formula () {
        let t = this

        return {
          values (index) {
            let total = t.form.sallary_json_array[index].child.reduce((a, item) => a + Number(item.nominal), 0), total_income = 0, total_deduction = 0

            t.form.sallary_json_array[index].nominal = Number(total)

            t.form.thp = 0

            t.form.sallary_json_array.forEach(obj => {
              if (obj.type === 'income') {
                total_income += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
              } 
              
              if (obj.type === 'deduction') {
                total_deduction += obj.child.reduce((a, item) => a + Number(item.nominal), 0)
              }
            })

            t.form.thp = total_income - total_deduction
          }
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/user_sallary/add' : 'admin/user_sallary/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/user_sallary/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      toUpload (id) {
        this.selected.upload = [id]

        this.dialog.upload = true
      },
      async uploads () {
        this.message.error = ''

        this.process.upload = true

        await post(`admin/user_sallary/update_slip`, {
          data: {
            id: this.selected.upload[0],
            slip_url: this.form.slip_url
          }
        }).then(response => {
          let res = response.data

          this.process.upload = false

          if (res.status === 200) {

            this.dialog.upload = false

            this.selected.row = []
            this.selected.upload = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>